import Vue from 'vue'
import VueRouter from 'vue-router'
import Card from "../components/card/Card";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'card',
    component: Card
  },
  {
    path: '/highscore',
    name: 'highscore',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/highscore/Highscore.vue')
  }
]

const router = new VueRouter({
    mode: 'history',
  routes
});

export default router
